import { useState } from 'react';
import { Link } from 'react-router-dom';

const distributors = [
  { name: 'Billabong Surf Shop', location: 'Huntington Beach, CA', region: 'usa', type: 'Surf Shop' },
  { name: 'Surfside Boards', location: 'San Diego, CA', region: 'usa', type: 'Surf Shop' },
  { name: 'Pacific Surf Co.', location: 'Santa Cruz, CA', region: 'usa', type: 'Surf Shop' },
  { name: 'Outer Island Surf', location: 'Oahu, HI', region: 'usa', type: 'Surf Shop' },
  { name: 'Cocoa Beach Surf Shop', location: 'Cocoa Beach, FL', region: 'usa', type: 'Surf Shop' },
  { name: 'Manly Surf Supplies', location: 'Manly, NSW', region: 'australia', type: 'Surf Shop' },
  { name: 'Gold Coast Board Co.', location: 'Surfers Paradise, QLD', region: 'australia', type: 'Surf Shop' },
  { name: 'Bells Beach Surf Shop', location: 'Torquay, VIC', region: 'australia', type: 'Surf Shop' },
  { name: 'Quiksilver Flagships', location: 'Multiple AU Locations', region: 'australia', type: 'Chain' },
  { name: 'Pukas Surf', location: 'San Sebastián, Spain', region: 'europe', type: 'Surf Shop' },
  { name: 'Biarritz Surf School', location: 'Biarritz, France', region: 'europe', type: 'Surf School' },
  { name: 'Newquay Surf Shop', location: 'Newquay, Cornwall UK', region: 'europe', type: 'Surf Shop' },
  { name: 'Fuerteventura Surf', location: 'Canary Islands, Spain', region: 'europe', type: 'Surf Shop' },
  { name: 'Bali Surf Supply', location: 'Kuta, Bali', region: 'asia', type: 'Surf Shop' },
  { name: 'Mentawai Surf Shop', location: 'Mentawai Islands, Indonesia', region: 'asia', type: 'Surf Shop' },
  { name: 'Tamarindo Surf', location: 'Tamarindo, Costa Rica', region: 'latam', type: 'Surf Shop' },
  { name: 'Pipeline Surf Co.', location: 'Puerto Escondido, Mexico', region: 'latam', type: 'Surf Shop' },
];

const regionLabels: Record<string, string> = {
  all: 'All Regions', usa: 'USA & Canada', australia: 'Australia & NZ',
  europe: 'Europe', asia: 'Asia Pacific', latam: 'Latin America',
};

const onlineRetailers = [
  { name: 'Amazon', icon: 'ri-shopping-cart-line', note: 'Prime eligible' },
  { name: 'Boardcave', icon: 'ri-store-line', note: 'AU + International' },
  { name: 'Cleanline Surf', icon: 'ri-store-2-line', note: 'US shipping' },
  { name: 'Surfboards.com', icon: 'ri-global-line', note: 'Worldwide' },
];

export default function StoreSection() {
  const [region, setRegion] = useState('all');
  const filtered = region === 'all' ? distributors : distributors.filter((d) => d.region === region);

  return (
    <section id="store-finder" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Online retailers */}
        <div className="mb-14">
          <p className="text-[#FF6B35] text-sm font-bold uppercase tracking-widest mb-3">Buy Online</p>
          <h2 className="text-3xl font-black text-stone-900 mb-8">Shop Online — Ship Worldwide</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {onlineRetailers.map((r) => (
              <a key={r.name} href="#" className="bg-[#F5EFE6] rounded-2xl p-6 text-center hover:-translate-y-1 transition-transform cursor-pointer group">
                <div className="w-12 h-12 rounded-xl bg-[#0B5C4D]/10 flex items-center justify-center mx-auto mb-3">
                  <i className={`${r.icon} text-[#0B5C4D] text-xl`} />
                </div>
                <p className="text-stone-900 font-bold text-sm group-hover:text-[#0B5C4D] transition-colors">{r.name}</p>
                <p className="text-stone-400 text-xs mt-1">{r.note}</p>
              </a>
            ))}
          </div>
        </div>

        {/* Retail locations */}
        <div>
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 mb-6">
            <h2 className="text-3xl font-black text-stone-900">Retail Locations</h2>
            <div className="flex flex-wrap gap-2">
              {Object.entries(regionLabels).map(([key, label]) => (
                <button
                  key={key}
                  onClick={() => setRegion(key)}
                  className={`whitespace-nowrap px-4 py-2 rounded-full text-xs font-bold transition-all cursor-pointer ${region === key ? 'bg-[#0B5C4D] text-white' : 'bg-stone-100 text-stone-600 hover:bg-stone-200'}`}
                >
                  {label}
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {filtered.map((d, idx) => (
              <div key={idx} className="border border-stone-100 rounded-xl p-4 flex items-start gap-4 hover:border-[#0B5C4D]/30 transition-colors">
                <div className="w-9 h-9 rounded-lg bg-[#F5EFE6] flex items-center justify-center flex-shrink-0">
                  <i className="ri-store-2-line text-[#0B5C4D] text-base" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-stone-900 font-bold text-sm truncate">{d.name}</h3>
                  <p className="text-stone-400 text-xs mt-0.5 flex items-center gap-1">
                    <i className="ri-map-pin-line text-[#FF6B35] text-xs" />
                    {d.location}
                  </p>
                  <span className="inline-block mt-1.5 text-xs bg-stone-100 text-stone-500 px-2 py-0.5 rounded-full">{d.type}</span>
                </div>
                <a href="#" className="whitespace-nowrap text-[#0B5C4D] text-xs font-bold hover:text-[#FF6B35] transition-colors cursor-pointer">Visit →</a>
              </div>
            ))}
          </div>

          <p className="text-center text-stone-400 text-sm mt-8">
            Can&apos;t find a retailer near you?{' '}
            <a href="mailto:hello@phixdoctor.com" className="text-[#0B5C4D] font-bold hover:text-[#FF6B35] transition-colors cursor-pointer">
              Contact us or order online.
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
